import { backend_client } from "../../../helpers/api";

const changeReviewedStatus = (examInstanceId, newReviewStatus) => {
  const endpoint = `/exam-instances/${examInstanceId}/change-review-status?new_review_status=${newReviewStatus}`;
  return backend_client.patch(endpoint);
};

export default changeReviewedStatus;
